module.exports = __webpack_public_path__ + "static/assets/38d28f686f56c0b05fd66e617ae2eef6.svg";